import { gql } from "@apollo/client";

export const LOAD_RESERVATION_OFFER_OPTION = gql`
  mutation loadReservationOfferOption($loadReservationOfferOptionInput: LoadReservationOfferOptionInput!) {
    loadReservationOfferOption(input: $loadReservationOfferOptionInput) {
      language
      reservationOfferOption {
        id
        isConfirmed
        accommodations {
          id
          guests {
            id
            personType
            age
          }
          checkIn
          checkOut
          ratePlan {
            id
          }
        }
      }
      carrier {
        firstName
        lastName
        countryIso
        address
        postalCode
        city
        email
        phoneNumber
        companyName
        companyAddress
        companyVatId
        companyCountryIso
      }
    }
  }
`;
